import React from 'react';
import { createPortal } from 'react-dom';
import { request, wrapView } from '../smart_bps/lib/utils';
import { Paginator } from '../smart_bps/lib/components';
import { stateToProps } from '../smart_bps/bps/base_view';
import { Link } from 'react-router-dom'

// Кастомный компонент тултипа
class CustomTooltip extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      show: false,
      position: { top: 0, left: 0 }
    };
    this.elementRef = React.createRef();
  }

  componentDidMount() {
    this.updatePosition();
  }

  updatePosition = () => {
    if (this.elementRef.current) {
      const rect = this.elementRef.current.getBoundingClientRect();
      const { position = 'top' } = this.props;

      let top, left;
      if (position === 'top') {
        top = rect.top - 10; // отступ от элемента
        left = rect.left + rect.width / 2; // центр элемента
      } else {
        top = rect.bottom + 10; // отступ от элемента
        left = rect.left + rect.width / 2; // центр элемента
      }

      this.setState({ position: { top, left } });
    }
  };

  handleMouseEnter = () => {
    this.updatePosition();
    this.setState({ show: true });
  };

  handleMouseLeave = () => {
    this.setState({ show: false });
  };

  render() {
    const { children, text, position = 'top', wrapperClassName } = this.props;
    const { show, position: tooltipPosition } = this.state;

    const tooltipElement = show ? (
      <div
        className="position-fixed"
        style={{
          zIndex: 9999,
          top: position === 'top' ? tooltipPosition.top - 40 : tooltipPosition.top,
          left: tooltipPosition.left,
          transform: 'translateX(-50%)',
          backgroundColor: '#343a40',
          color: 'white',
          padding: '0.5rem 0.75rem',
          borderRadius: '0.375rem',
          fontSize: '0.75rem',
          whiteSpace: 'nowrap',
          boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
          pointerEvents: 'none'
        }}
      >
        {text}
        <div
          className="position-absolute"
          style={{
            width: 0,
            height: 0,
            borderLeft: '5px solid transparent',
            borderRight: '5px solid transparent',
            ...(position === 'top' ? {
              top: '100%',
              left: '50%',
              transform: 'translateX(-50%)',
              borderTop: '5px solid #343a40'
            } : {
              bottom: '100%',
              left: '50%',
              transform: 'translateX(-50%)',
              borderBottom: '5px solid #343a40'
            })
          }}
        />
      </div>
    ) : null;

    return (
      <>
        <div
          ref={this.elementRef}
          className={wrapperClassName || 'd-inline-block'}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
        >
          {children}
        </div>
        {tooltipElement && createPortal(tooltipElement, document.body)}
      </>
    );
  }
}

class NotificationsWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      unreadCount: 0,
      notifications: [],
      loading: false,
      loadingMore: false,
      current_page: 1,
      has_next_page: false,
      count_pages: 0,
      showImportantOnly: false,
      showUnreadOnly: false,
      hoveredNotification: null,
    };
    this.updateItems = this.updateItems.bind(this);
  }

  componentDidMount() {
    this.loadUnreadCount();
    this.loadNotifications();

    // Обновляем каждые 30 секунд
    this.interval = setInterval(() => {
      this.loadUnreadCount();
    }, 30000);
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  loadUnreadCount = () => {
    request({
      method: 'GET',
      url: '/api/notifications/unread_count',
      success: (data) => {
        this.setState({ unreadCount: data.unread_count || 0 });
      },
      error: (error) => {
        console.error('Ошибка загрузки количества:', error);
        this.setState({ unreadCount: 0 });
      }
    });
  };

  updateItems = (page) => {
    this.setState({ loading: true });

    const params = new URLSearchParams({
      limit: '5',
      offset: `${(page - 1) * 5}`
    });

    if (this.state.showImportantOnly) {
      params.append('important_only', 'true');
    }

    if (this.state.showUnreadOnly) {
      params.append('unread_only', 'true');
    }

    request({
      method: 'GET',
      url: `/api/notifications/?${params.toString()}`,
      success: (data) => {
        this.setState({
          notifications: data.notifications || [],
          loading: false,
          current_page: page,
          has_next_page: data.has_next_page || false,
          count_pages: data.count_pages || 0,
        });
      },
      error: (error) => {
        console.error('Ошибка загрузки уведомлений:', error);
        this.setState({
          notifications: [],
          loading: false
        });
      }
    });
  };

  loadNotifications = () => {
    this.updateItems(1);
  };

  loadMoreNotifications = () => {
    if (this.state.loadingMore || !this.state.has_next_page) return;

    this.setState({ loadingMore: true });
    const nextPage = this.state.current_page + 1;

    const params = new URLSearchParams({
      limit: '5',
      offset: `${(nextPage - 1) * 5}`
    });

    if (this.state.showImportantOnly) {
      params.append('important_only', 'true');
    }

    if (this.state.showUnreadOnly) {
      params.append('unread_only', 'true');
    }

    request({
      method: 'GET',
      url: `/api/notifications/?${params.toString()}`,
      success: (data) => {
        this.setState(prevState => ({
          notifications: [...prevState.notifications, ...(data.notifications || [])],
          loadingMore: false,
          current_page: nextPage,
          has_next_page: data.has_next_page || false,
          count_pages: data.count_pages || 0,
        }));
      },
      error: (error) => {
        console.error('Ошибка загрузки дополнительных уведомлений:', error);
        this.setState({ loadingMore: false });
      }
    });
  };

  markAsRead = (notificationId) => {
    request({
      method: 'POST',
      url: `/api/notifications/${notificationId}/mark-read`,
      success: () => {
        this.loadUnreadCount();
        this.updateNotificationInState(notificationId, { is_read: true });
      }
    });
  };

  markAllAsRead = () => {
    request({
      method: 'POST',
      url: '/api/notifications/mark-all-read',
      success: () => {
        this.loadUnreadCount();
        this.setState(prevState => ({
          notifications: prevState.notifications.map(notification => ({
            ...notification,
            is_read: true
          }))
        }));
      }
    });
  };



  toggleImportant = (notificationId) => {
    request({
      method: 'POST',
      url: `/api/notifications/${notificationId}/toggle-important`,
      success: () => {
        this.updateNotificationInState(notificationId, (notification) => ({
          is_important: !notification.is_important
        }));
      }
    });
  };

  toggleImportantFilter = () => {
    this.setState(prevState => ({
      showImportantOnly: !prevState.showImportantOnly,
      current_page: 1
    }), () => {
      this.loadNotifications();
    });
  };

  toggleUnreadFilter = () => {
    this.setState(prevState => ({
      showUnreadOnly: !prevState.showUnreadOnly,
      current_page: 1
    }), () => {
      this.loadNotifications();
    });
  };

  deleteNotification = (notificationId) => {
    request({
      method: 'DELETE',
      url: `/api/notifications/${notificationId}`,
      success: () => {
        this.loadUnreadCount();
        this.setState(prevState => ({
          notifications: prevState.notifications.filter(notification => notification.id !== notificationId)
        }));
      }
    });
  };

  handleMouseEnter = (notificationId) => {
    this.setState({ hoveredNotification: notificationId });
  };

  handleMouseLeave = () => {
    this.setState({ hoveredNotification: null });
  };

  updateNotificationInState = (notificationId, updates) => {
    this.setState(prevState => ({
      notifications: prevState.notifications.map(notification => {
        if (notification.id === notificationId) {
          if (typeof updates === 'function') {
            return { ...notification, ...updates(notification) };
          }
          return { ...notification, ...updates };
        }
        return notification;
      })
    }));
  };



  formatDate = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Только что';
    if (diffMins < 60) return `${diffMins} мин назад`;
    if (diffHours < 24) return `${diffHours} ч назад`;
    if (diffDays < 7) return `${diffDays} дн назад`;

    return date.toLocaleDateString('ru-RU');
  };

  getNotificationIcon = (type) => {
    const icons = {
      'survey_completed': 'ti-clipboard-check',
      'eyetracker_completed': 'ti-eye',
      'reminder_created': 'ti-alarm',
      'reminder_assigned': 'ti-user-check',
      'reminder_transferred': 'ti-user-plus',
      'reminder_auto_created': 'ti-alarm-plus',
      'system_alert': 'ti-alert-circle',
      'user_message': 'ti-message-circle',
      'report_ready': 'ti-file-text',
      'deadline_approaching': 'ti-clock',
      'assignment_received': 'ti-briefcase',
      'comment_added': 'ti-message-circle-2'
    };
    return icons[type] || 'ti-bell';
  };

  getNotificationTypeLabel = (type) => {
    const labels = {
      'completed_approval': 'Завершение согласования',
      'return_to_rework': 'Возврат на доработку',
      'request_rework': 'Доработка заявки',
      'received_request': 'Проверка заявки',
      'access_refuse': 'Доступ не согласован',
      'contractor_registration': 'Регистрация подрядчика',
      'file_expire': 'Истёк срок действия файла',
    };
    return labels[type] || type;
  };

  getRelatedObjectUrl = (notification) => {
    const { related_object_type, related_object_id } = notification;

    if (!related_object_type || !related_object_id) {
      return null;
    }

    // Маппинг типов объектов на URL
    // Для surveys используем 'default' как наиболее распространенную категорию
    // В будущем можно доработать для передачи конкретной категории через data
    const urlMappings = {
      'survey': `/#/surveys/default/${related_object_id}`,
      'surveys': `/#/surveys/default/${related_object_id}`,
      'eyetracker': `/#/eyetracker/${related_object_id}`,
      'reminder': `/#/reminder/${related_object_id}`,
      'subject': `/#/subjects/${related_object_id}`,
      'subjects': `/#/subjects/${related_object_id}`,
      'institution': `/#/institutions/${related_object_id}`,
      'institutions': `/#/institutions/${related_object_id}`,
      'schedule': `/#/scheduling/${related_object_id}`,
      'scheduling': `/#/scheduling/${related_object_id}`,
      'recommendation': `/#/recommendations/${related_object_id}`,
      'recommendations': `/#/recommendations/${related_object_id}`,
    };

    return urlMappings[related_object_type.toLowerCase()] || null;
  };

  handleNotificationClick = (notification) => {
    // Клик на уведомление только отмечает его как прочитанное
    if (!notification.is_read) {
      this.markAsRead(notification.id);
    }
  };

  handleLinkClick = (notification, e) => {
    // Клик на иконку ссылки переходит к связанной карточке
    e.stopPropagation(); // Останавливаем всплытие события

    const relatedUrl = this.getRelatedObjectUrl(notification);
    if (relatedUrl) {
      window.location.href = relatedUrl;
    }
  };
  renderCommentWithLinks = (notifyData) => {
    const commentMsg = notifyData?.message
    if (!commentMsg) return null
    const actionLink = notifyData.data?.action_link
    if (!actionLink || (!actionLink?.url || !actionLink?.text)) return notifyData.message

    const orangeLinkTypes = new Set(['contractor_registration', 'request_rework'])
    const useOrangeLink = orangeLinkTypes.has(notifyData.notification_type)

    const parts = commentMsg.split(actionLink.text);
    return parts.map((part, index) => (
      <React.Fragment key={index}>
        {part}
        {index < parts.length - 1 && (
          <Link
            to={actionLink.url}
            className={useOrangeLink ? 'text-decoration-none' : 'text-primary text-decoration-none'}
            style={useOrangeLink ? { color: '#ff5a00' } : undefined}
            target="_blank"
            rel="noopener noreferrer"
          >
            {actionLink.text}
          </Link>
        )}
      </React.Fragment>
    ));
  }
  render() {
    const { unreadCount, notifications, loading } = this.state;
    // Проверяем роль пользователя
    const userRoles = this.props.user?.roles || [];
    const isSubject = userRoles.includes('subject');

    // Если пользователь - испытуемый, не показываем иконку уведомлений
    if (isSubject) {
      return null;
    }

    return (
      <>
        <a
          className="nav-link position-relative d-flex align-items-center"
          title="Уведомления"
          data-bs-toggle="dropdown"
        //   data-bs-auto-close="false"
          aria-expanded="false"
          style={{
            padding: '0.5rem 0.75rem',
            borderRadius: '0.375rem',
            transition: 'all 0.2s ease-in-out'
          }}
        >
          <div className="position-relative">
            <i className="ti ti-bell" style={{ fontSize: '1.1rem' }}></i>
            {unreadCount > 0 && (
              <span
                className="position-absolute top-0 start-100 translate-middle badge rounded-pill"
                style={{
                  fontSize: '0.65rem',
                  minWidth: '18px',
                  height: '18px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: '0 6px',
                  fontWeight: 500,
                  boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
                  backgroundColor: '#ff5a00',
                }}
              >
                {unreadCount > 99 ? '99+' : unreadCount}
              </span>
            )}
          </div>
        </a>

        <div
          className="dropdown-menu dropdown-menu-end mt-2 shadow border sigur-notifications-menu"
          style={{
            width: '380px',
            maxHeight: '450px',
            overflowY: 'auto',
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="dropdown-header d-flex justify-content-between align-items-center py-2 px-3 border-bottom">
            <div className="fw-medium text-dark" style={{ fontSize: '0.9rem' }}>
              Уведомления
            </div>
            <div className="sigur-notifications-menu__actions">
              <CustomTooltip
                text={this.state.showImportantOnly ? "Показать все уведомления" : "Показать только важные"}
                position="top"
                wrapperClassName="sigur-notifications-menu__action-wrap"
              >
                <button
                  type="button"
                  className={`sigur-notifications-menu__action-btn ${this.state.showImportantOnly ? 'sigur-notifications-menu__action-btn--active-star' : ''}`}
                  onClick={this.toggleImportantFilter}
                  aria-label={this.state.showImportantOnly ? 'Показать все уведомления' : 'Показать только важные'}
                >
                  <i className={`ti sigur-notifications-menu__action-icon ${this.state.showImportantOnly ? 'ti-star-filled' : 'ti-star'}`} />
                </button>
              </CustomTooltip>
              <CustomTooltip
                text={this.state.showUnreadOnly ? "Показать все уведомления" : "Показать только не прочитанные"}
                position="top"
                wrapperClassName="sigur-notifications-menu__action-wrap"
              >
                <button
                  type="button"
                  className={`sigur-notifications-menu__action-btn ${this.state.showUnreadOnly ? 'sigur-notifications-menu__action-btn--active-mail' : ''}`}
                  onClick={this.toggleUnreadFilter}
                  aria-label={this.state.showUnreadOnly ? 'Показать все уведомления' : 'Показать только не прочитанные'}
                >
                  <i className={`ti sigur-notifications-menu__action-icon ${this.state.showUnreadOnly ? 'ti-mail-filled' : 'ti-mail'}`} />
                </button>
              </CustomTooltip>
              {unreadCount > 0 && (
                <CustomTooltip
                  text="Отметить все как прочитанные"
                  position="top"
                  wrapperClassName="sigur-notifications-menu__action-wrap"
                >
                  <button
                    type="button"
                    className="sigur-notifications-menu__action-btn"
                    onClick={this.markAllAsRead}
                    aria-label="Отметить все как прочитанные"
                  >
                    <i className="ti ti-mail-opened sigur-notifications-menu__action-icon" />
                  </button>
                </CustomTooltip>
              )}
            </div>
          </div>

          {loading ? (
            <div className="dropdown-item text-center py-4">
              <div className="spinner-border spinner-border-sm text-primary" role="status">
                <span className="visually-hidden">Загрузка...</span>
              </div>
              <div className="small text-muted mt-2">Загрузка уведомлений...</div>
            </div>
          ) : notifications.length === 0 ? (
            <div className="dropdown-item text-center py-4">
              <i className="ti ti-bell-off text-muted" style={{ fontSize: '2rem' }}></i>
              <div className="text-muted mt-2">Нет уведомлений</div>
              <div className="small text-muted">Новые уведомления появятся здесь</div>
            </div>
          ) : (
            notifications.map(notification => {
              const hasRelatedLink = this.getRelatedObjectUrl(notification);
              return (
                <div
                  key={notification.id}
                  className={`dropdown-item sigur-notifications-menu__item ${hasRelatedLink ? 'notification-with-link' : ''}`}
                  onClick={() => this.handleNotificationClick(notification)}
                  onMouseEnter={() => this.handleMouseEnter(notification.id)}
                  onMouseLeave={this.handleMouseLeave}
                >
                <div>
                  <div className="d-flex align-items-start">
                    <div className={`me-2 mt-1 ${!notification.is_read ? 'text-primary' : 'text-muted'}`}>
                      <i className={`ti ${this.getNotificationIcon(notification.notification_type)}`}></i>
                    </div>
                    <div className="flex-grow-1" style={{ minWidth: 0 }}>
                        <div className={`fw-medium ${!notification.is_read ? 'text-dark' : 'text-muted'} d-flex align-items-center`} style={{
                          fontSize: '0.9rem',
                          wordWrap: 'break-word',
                          overflowWrap: 'break-word',
                          whiteSpace: 'normal'
                        }}>
                          {notification.title}
                          {hasRelatedLink && (
                            <i
                              className="ti ti-external-link ms-1"
                              style={{
                                fontSize: '0.75rem',
                                color: '#7367f0',
                                opacity: 0.7,
                                cursor: 'pointer'
                              }}
                              onClick={(e) => this.handleLinkClick(notification, e)}
                              title="Перейти к карточке"
                            ></i>
                          )}
                        </div>
                      <div className="text-muted mt-1" style={{
                        fontSize: '0.8rem',
                        lineHeight: '1.4',
                        wordWrap: 'break-word',
                        overflowWrap: 'break-word',
                        whiteSpace: 'normal'
                      }}>
                        {this.renderCommentWithLinks(notification)}
                        {notification.notification_type === 'comment_added' && notification.data && (
                          <div className="mt-2 p-2 bg-light rounded" style={{ fontSize: '0.75rem' }}>
                            <div className="text-muted mb-1">
                              <i className="ti ti-user me-1"></i>
                              {notification.data.author_name}
                            </div>
                            <div className="text-dark">
                              <i className="ti ti-message me-1"></i>
                              {this.renderCommentWithLinks(notification)}
                            </div>
                          </div>
                        )}
                        {['reminder_assigned', 'reminder_transferred', 'reminder_auto_created'].includes(notification.notification_type) && notification.data && (
                          <div className="mt-3 p-3  rounded-3" style={{
                            fontSize: '0.8rem',
                            backgroundColor: '#f8f9fa',
                            boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                          }}>
                            <div className="d-flex align-items-center mb-2">
                              <div className="me-2" style={{
                                width: '24px',
                                height: '24px',
                                backgroundColor: '#7367f0',
                                borderRadius: '50%',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center'
                              }}>
                                <i className="ti ti-alarm text-white" style={{ fontSize: '0.7rem' }}></i>
                              </div>
                              <div className="fw-semibold text-dark" style={{ fontSize: '0.85rem' }}>
                                Напоминание #{notification.data.reminder_id}
                              </div>
                            </div>

                            {notification.data.reminder_name && (
                              <div className="mb-2 p-2 rounded-2" style={{
                                backgroundColor: '#ffffff',
                                border: '1px solid #e9ecef'
                              }}>
                                <div className="d-flex align-items-start">
                                  <i className="ti ti-file-text text-primary me-2 mt-1" style={{ fontSize: '0.75rem' }}></i>
                                  <div className="text-dark" style={{
                                    lineHeight: '1.4',
                                    wordBreak: 'break-word'
                                  }}>
                                    {notification.data.reminder_name}
                                  </div>
                                </div>
                              </div>
                            )}

                            {notification.data.assigned_at && (
                              <div className="d-flex align-items-center text-muted" style={{ fontSize: '0.75rem' }}>
                                <i className="ti ti-clock me-1"></i>
                                <span>Назначено: {new Date(notification.data.assigned_at).toLocaleString('ru-RU')}</span>
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                      <div className="small text-muted mt-2 d-flex align-items-center justify-content-between">
                        <div className="d-flex align-items-center">
                          <i className="ti ti-clock me-1"></i>
                          {this.formatDate(notification.d_create)}
                          {notification.notification_type && (
                            <span
                              className="badge bg-secondary ms-2"
                              style={{
                                fontSize: '0.65rem',
                                marginRight: '0.5rem',
                                padding: '0.3rem'
                              }}
                            >
                            {this.getNotificationTypeLabel(notification.notification_type)}
                            </span>
                          )}
                        </div>
                        {this.state.hoveredNotification === notification.id && (
                          <div className="d-flex">
                            <CustomTooltip
                              text={notification.is_important ? "Убрать из важных" : "Отметить как важное"}
                              position="top"
                            >
                              <button
                                className={`btn btn-sm me-1 ${notification.is_important ? 'btn-warning' : 'btn-outline-warning'}`}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.toggleImportant(notification.id);
                                }}
                                style={{ padding: '0.25rem 0.5rem' }}
                              >
                                <i className={`ti ${notification.is_important ? 'ti-star-filled' : 'ti-star'}`} style={{ fontSize: '0.75rem' }}></i>
                              </button>
                            </CustomTooltip>
                            <CustomTooltip
                              text="Удалить"
                              position="top"
                            >
                              <button
                                className="btn btn-sm btn-outline-danger"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  this.deleteNotification(notification.id);
                                }}
                                style={{ padding: '0.25rem 0.5rem' }}
                              >
                                <i className="ti ti-trash" style={{ fontSize: '0.75rem' }}></i>
                              </button>
                            </CustomTooltip>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              );
            })
          )}

          {notifications.length > 0 && (
            <>
              <div className="dropdown-divider my-0"></div>
              <div className="text-center py-2 px-3">
                <div className="d-flex flex-column gap-2">
                  {this.state.has_next_page && (
                    <button
                      className="btn btn-outline-primary btn-sm"
                      onClick={this.loadMoreNotifications}
                      disabled={this.state.loadingMore}
                      style={{ fontSize: '0.8rem' }}
                    >
                      {this.state.loadingMore ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Загрузка...
                        </>
                      ) : (
                        <>
                          <i className="ti ti-plus me-1"></i>
                          Загрузить еще
                        </>
                      )}
                    </button>
                  )}
                  {this.state.count_pages > 1 && (
                    <Paginator
                      current_page={this.state.current_page}
                      count_pages={this.state.count_pages}
                      has_next={this.state.has_next_page}
                      setPage={this.updateItems}
                    />
                  )}
                </div>
              </div>
            </>
          )}
        </div>
      </>
    );
  }
}

export default wrapView(NotificationsWidget, (state) => {
  return stateToProps(state, 'notifications')
});
